import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Observable } from 'rxjs';
import { revisione53DatiFormSelectors } from '../../../store/selectors/dati-form.selectors';
import { CoopAltreCoopFormListeners } from './listeners/coop-altre-coop.form-listeners';
import { CoopAltreCoopFormValidators } from './validators/coop-altre-coop.form-validators';
import { manageSchedaDisabled, manageScObbl } from '../common/helper/scheda-settore.helper';
import { BaseRevisioneFormService } from '../../../abstracts/base-revisione-form.service';
import { DatiIdentificativiFormService } from '../../dati-identificativi/dati-identificativi-form.service';
import { formPaths } from '@shared/constants/form-paths.const';

@Injectable()
export class SchedaCoopAltreCoopFormService extends BaseRevisioneFormService {
    isDisabled$: Observable<boolean>;

    constructor(protected datiIdentificativiService: DatiIdentificativiFormService) {
        super(undefined, undefined, datiIdentificativiService);
    }

    override get dependencyPaths(): Set<string> {
        return new Set([
            // Dati identificativi
            `${formPaths.datiIdentificativi}.my_ckSezAlboCorretta`,
            `${formPaths.datiIdentificativi}.my_TipoSezEnte`,
            `${formPaths.datiIdentificativi}.my_SezEnte`,

            // Scheda coop sociali
            `${formPaths.schedaCoopSociali}.my_ScSocObbl`,

            // Scheda coop edilizie
            `${formPaths.schedaCoopEdil}.my_ScEdilObbl`,

            // Scheda coop consumo
            `${formPaths.schedaCoopConsumo}.my_ScConsumoObbl`,

            // Scheda coop PDL
            `${formPaths.schedaCoopPDL}.my_ScPDLObbl`,

            // Scheda coop agricole
            `${formPaths.schedaCoopAgricole}.my_ScAgricoleObbl`,

            // Scheda coop trasporto
            `${formPaths.schedaCoopTrasporto}.my_ScTrasportoObbl`,

            // Scheda coop pesca
            `${formPaths.schedaCoopPesca}.my_ScPescaObbl`,

            // Scheda coop fidi
            `${formPaths.schedaCoopFidi}.my_ScCoopFidiObbl`,

            // Scheda coop dettaglianti
            `${formPaths.schedaCoopDettaglianti}.my_ScCoopDettagliObbl`,
        ]);
    }

    override initListener() {
        new CoopAltreCoopFormListeners(this._form, this.store).setListeners();
    }

    protected override initForm(): FormGroup {
        return this.fb.group(
            {
                my_SezioneI__Rilevazione: this.fb.group({
                    my_SchedaCoopAltreCoop: this.fb.group({
                        my_ScAltreCoopObbl: '',
                        my_AltreCoopAttivitaPrevalente: '',
                        my_AltreCoopNote: '',
                        my_CkAltreCoopAllegaSchedaGaranziaFidi: '0',
                        my_CkAltreCoopAllegaSchedaPesca: '0',
                        my_CkAltreCoopAllegaSchedaTrasporto: '0',
                        my_CkAltreCoopAllegaSchedaAgricole: '0',
                        my_CkAltreCoopAllegaSchedaAgricoleConferimento: '0',
                        my_CkAltreCoopAllegaSchedaAgricoleConsorzi: '0',
                        my_CkAltreCoopAllegaSchedaPDL: '0',
                        my_CkAltreCoopAllegaSchedaConsumo: '0',
                        my_CkAltreCoopAllegaSchedaSociali: '0',
                        my_CkAltreCoopAllegaSchedaEdilizie: '0',
                        my_AltreCoopTipoScambioMutua: '',
                        my_CkAltreCoopAllegaSchedaDettaglianti: '0',
                        my_descNoSchedeCompilate: '',
                    }),
                    my_DatiIdentificativi: this.fb.group({
                        my_ckSezAlboCorretta: '',
                        my_TipoSezEnte: '',
                        my_SezEnte: '',
                    }),

                    my_SchedaCoopSociali: this.fb.group({
                        my_ScSocObbl: '',
                    }),

                    my_SchedaCoopEdil: this.fb.group({
                        my_ScEdilObbl: '',
                    }),

                    my_SchedaCoopConsumo: this.fb.group({
                        my_ScConsumoObbl: '',
                    }),

                    my_SchedaCoopPDL: this.fb.group({
                        my_ScPDLObbl: '',
                    }),

                    my_SchedaCoopAgricole: this.fb.group({
                        my_ScAgricoleObbl: '',
                    }),

                    my_SchedaCoopTrasporto: this.fb.group({
                        my_ScTrasportoObbl: '',
                    }),

                    my_SchedaCoopPesca: this.fb.group({
                        my_ScPescaObbl: '',
                    }),

                    my_SchedaCoopFidi: this.fb.group({
                        my_ScCoopFidiObbl: '',
                    }),

                    my_SchedaCoopDettaglianti: this.fb.group({
                        my_ScCoopDettagliObbl: '',
                    }),
                }),
            },
            {
                updateOn: 'change',
                validators: CoopAltreCoopFormValidators,
            }
        );
    }

    protected override afterFormInitialize(): void {
        this._manageDeactivation();
        manageScObbl(this.datiIdentificativiFormService, this._form, `${formPaths.schedaAltreCoop}.my_ScAltreCoopObbl`);
    }

    private _manageDeactivation(): void {
        this.isDisabled$ = manageSchedaDisabled(this.store, revisione53DatiFormSelectors.getScAltreCoopObbl);
    }
}
